import { FilterHandlerBase } from './base/filter-handler-base';
import { AdvancedFilterName, FilterPassParams } from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { CouponOption } from '../../../types/deal.types';
import { CouponMaturityLevelFilter } from '../maturity-level-filters/coupon-maturity-level-filter';

export class CouponAdvancedFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.coupon;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    let isCouponFilterPassed = true;
    const coupon = params.filters[this.name];
    const data = params.deal;
    if (coupon) {
      const { model }: { model: CouponOption } = coupon;
      const filter = new CouponMaturityLevelFilter(model);
      isCouponFilterPassed = data.maturities.some(maturity =>
        filter.applyFilter(maturity)
      );
    }
    result.applyDealFilerResult(data.id, this.name, isCouponFilterPassed);

    return isCouponFilterPassed;
  }
}
